<style scoped lang="scss">
.property-modal {
    .uk-modal-dialog {
        width: 800px;
    }
}
</style>

<template>
    <vk-modal class="property-modal uk-width-1-1" :show.sync="isOpen">
        <vk-modal-title>Add New Property</vk-modal-title>
        <div class="uk-grid">
            <div class="uk-width-1-1 uk-article-lead">
                <span>Property Type</span>
            </div>
            <div class="uk-width-1-1 uk-margin-small-top">
                <select class="uk-form-large uk-width-1-1" v-model="propertyType">
                    <option :value="null">Please Select a Property Type</option>
                    <option v-for="(type, value) in propertyTypes" :value="value">{{ type }}</option>
                </select>
            </div>


            <div class="uk-width-1-1 uk-article-lead uk-margin-top">
                <span>Property Address</span>
            </div>
            <div class="uk-width-1-1">
                <address-form
                        :show-name="propertyType == 1"
                        name-text="Property Name"
                        class="uk-margin-top"></address-form>
            </div>


            <div class="uk-width-1-1 uk-article-lead uk-margin-top">
                <span class="uk-margin-left">Do you know who manages this property?</span>
            </div>
            <div class="uk-width-1-1" v-if="propertyManagerKnown">
                <address-form class="uk-margin-top"></address-form>
            </div>

            <div class="uk-width-1-1 uk-article-lead uk-margin-top">
                <toggle-button v-model="propertyOwnerKnown"></toggle-button>
                <span class="uk-margin-left">Do you know who owns this property?</span>
            </div>
            <div class="uk-width-1-1 uk-article-lead uk-margin-top" v-if="propertyOwnerKnown">
                <toggle-button v-model="propertyManagerOwnerSame"></toggle-button>
                <span class="uk-margin-left">Is the property owner the same as the property manager?</span>
            </div>
            <div class="uk-width-1-1" v-if="propertyOwnerKnown && !propertyManagerOwnerSame">
                <address-form class="uk-margin-top"></address-form>
            </div>
        </div>
    </vk-modal>
</template>

<script>
    import AddressForm from "./AddressForm";
    export default {
        name: "AddPropertyModal",
        components: {AddressForm},
        data() {
            return {
                isOpen: false,
                propertyManagerKnown: false,
                propertyManagerOwnerSame: true,
                propertyOwnerKnown: false,
                propertyType: null,

                propertyTypes: {
                    1: 'Apartment',
                    2: 'Single Family Home',
                },
            }
        },
        methods: {
            open() {
                this.isOpen = true;
            }
        }
    }
</script>
